import $ from 'jquery'
import 'slick-carousel'
import { formatMoney, throttle, updateQueryStringParameter } from './helpers'
import axios from 'axios'

const tbIds = {
  grey: 15109665390658,
  blackAndGold: 15109665521730,
  black: 15109665423426,
  cognac: 40288698040386,
  cream: 40288993017922,
  veganBlack: 31311822422082,
  sable: 40092713320514,
  orchird: 40503457382466,
  snowLeopard: 40503457415234,
  tweed: 40503457448002,
  metallic: 40756546207810,
  python: 41161965600834,
  charcoal: 40092713287746,
  blueStripe: 41424924278850,
  veganSand: 41424888922178,
}

/*
  -------------
  SAVE ORIGINAL SLIDES BEFORE INIT
  -------------
*/
const $originalMainImages = $('.main-product-images-images').children().clone(true, true)

const $originalMainThumbs = $('.main-product-images-thumbs').children().clone(true, true)

/*
  Image sliders
*/
$('.main-product-images-images').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  // Pause any playing video on slide change
  const currentVideo = $(slick.$slides[currentSlide]).find('video')
  if (currentVideo.length) {
    currentVideo.get(0).pause()
  }
})

$('.main-product-images-images').on('afterChange', function (event, slick, currentSlide) {
  const currentSlideElement = $(slick.$slides[currentSlide])

  // Check if the current slide contains a video
  const video = currentSlideElement.find('video')
  if (video.length) {
    // Set video attributes: loop and hide controls
    video.attr({
      loop: true,
      controls: false,
    })

    // Play the video if present
    video.get(0).play()
  }
})

// Initialize slick for main images
$('.main-product-images-images').slick({
  dots: false,
  arrows: true,
  fade: true,
  cssEase: 'linear',
  asNavFor: '.main-product-images-thumbs',
  focusOnSelect: true,
  adaptiveHeight: false,
  infinite: false,
  responsive: [],
})

// Initialize slick for thumbs
$('.main-product-images-thumbs').slick({
  dots: false,
  arrows: true,
  centerMode: false,
  infinite: false,
  asNavFor: '.main-product-images-images',
  slidesToShow: 6,
  slidesToScroll: 1,
  vertical: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1039,
      settings: {
        slidesToShow: 12,
        slidesToScroll: 1,
        vertical: false,
      },
    },
    {
      breakpoint: 740,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: false,
      },
    },
  ],
})

/*
  Swatch images
*/
// Assuming `productColorSwatches` and `colorSwatches` exist somewhere
$('.main-product-color-swatch-img').each(function () {
  const name = $(this).attr('data-name').toLowerCase()
  const swatch = productColorSwatches[name] ? productColorSwatches[name] : colorSwatches[name]

  if (swatch) {
    $(this).attr('src', swatch.image)
  }
})

/*
  Update page details
*/

function findSelectedVariant(variants, selectedOptions) {
  if (variants.length === 1) {
    return variants[0]
  }

  // Tushbaby lite annoying
  if (selectedOptions[0] === 'Tushbaby Lite') {
    const selected = variants.find((v) => {
      return v.id === 40092713287746
    })
    return selected
  }

  const selected = variants.find((variant) => {
    let pass = true

    if (selectedOptions[0] && selectedOptions[0] !== variant.option1) {
      pass = false
    }

    if (selectedOptions[1] && selectedOptions[1] !== variant.option2) {
      pass = false
    }

    if (selectedOptions[2] && selectedOptions[2] !== variant.option3) {
      pass = false
    }

    return pass
  })

  return selected
}

function getSelectedOptions(root) {
  const selectedValues = []

  root.find('select.main-product-selector, .main-product-selector:checked').each(function () {
    selectedValues.push($(this).val())
  })

  return selectedValues
}

function getProductJson(root) {
  const data = root.attr('data-product')
  const json = JSON.parse(data)
  return json
}

function updatePageDetails(root) {
  /*
    Get selected variant
  */
  const globalImages = root.attr('data-global-images')
  const selectedOptions = getSelectedOptions(root)
  const json = getProductJson(root)
  const selectedVariant = findSelectedVariant(json.variants, selectedOptions)

  /*
    Add class to root
  */
  root.attr('class', function (i, className) {
    let classes = className.split(/\s+/)
    let filteredClasses = classes.filter((c) => !c.startsWith('main-product--variant-'))
    return filteredClasses.join(' ')
  })

  root.addClass(`main-product--variant-${selectedVariant.id}`)

  /*
    Update page details
  */
  // Update id
  root.find('[name="id"]').eq(0).val(selectedVariant.id)

  // Update url
  const qs = updateQueryStringParameter(window.location.href, 'variant', selectedVariant.id)
  window.history.replaceState(null, null, qs)

  // Update option names
  root.find('.main-product-option input:checked, .main-product-option select').each(function () {
    $(this).parents('.main-product-option').find('.main-product-option-name').text($(this).val())
  })

  // Update price via section render
  const url = `/products/${json.handle}?variant=${selectedVariant.id}&section_id=main-product`
  axios.get(url).then(function (pricesRes) {
    const dom = document.createElement('div')
    dom.innerHTML = pricesRes.data

    const newPrices = dom.querySelector('.product-prices').innerHTML
    root.find('.product-prices').html(newPrices)
  })

  // Update final sale
  const finalSaleEl = $('.main-product__badge--final-sale')
  const finalSaleElActive = 'main-product__badge--active'
  if (finalSaleEl && finalSale[selectedVariant.id]) {
    finalSaleEl.addClass(finalSaleElActive)
  } else if (finalSaleEl) {
    finalSaleEl.removeClass(finalSaleElActive)
  }

  // Update affirm (if needed)
  if ($('.affirm-as-low-as').length > 0 && affirm?.ui?.refresh) {
    $('.affirm-as-low-as').attr('data-amount', selectedVariant.price)
    affirm.ui.refresh()
  }

  // -------------
  // FIX: Always restore from original slides, re-init, then filter
  // -------------
  if (globalImages === undefined) {
    const $imagesWrapper = root.find('.main-product-images-images')
    const $thumbsWrapper = root.find('.main-product-images-thumbs')

    // Destroy existing slick
    $imagesWrapper.slick('unslick')
    $thumbsWrapper.slick('unslick')

    // Restore original slides from clones
    $imagesWrapper.empty().append($originalMainImages.clone(true, true))
    $thumbsWrapper.empty().append($originalMainThumbs.clone(true, true))

    // Reinitialize slick
    $imagesWrapper.slick({
      dots: false,
      arrows: true,
      fade: true,
      cssEase: 'linear',
      asNavFor: '.main-product-images-thumbs',
      focusOnSelect: true,
      adaptiveHeight: false,
      infinite: false,
    })

    $thumbsWrapper.slick({
      dots: false,
      arrows: true,
      centerMode: false,
      infinite: false,
      asNavFor: '.main-product-images-images',
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1039,
          settings: {
            slidesToShow: 12,
            slidesToScroll: 1,
            vertical: false,
          },
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            vertical: false,
          },
        },
      ],
    })

    // Now filter
    $imagesWrapper.slick('slickFilter', function (_, div) {
      const alt = div.querySelector('img').getAttribute('alt')
      const hasAlt = alt.indexOf(selectedVariant.id) > -1
      const isSuper = alt.indexOf('::[super-image]') > -1
      return hasAlt || isSuper
    })

    $thumbsWrapper.slick('slickFilter', function (_, div) {
      const alt = div.querySelector('img').getAttribute('alt')
      const hasAlt = alt.indexOf(selectedVariant.id) > -1
      const isSuper = alt.indexOf('::[super-image]') > -1
      return hasAlt || (isSuper && selectedVariant.id !== tbIds.charcoal && selectedVariant.id !== tbIds.blueStripe)
    })

    // Reset slides’ data-slick-index
    $imagesWrapper.find('.slick-slide:not(.slick-cloned)').each(function (index, slide) {
      $(slide).attr('data-slick-index', index)
    })

    $thumbsWrapper.find('.slick-slide:not(.slick-cloned)').each(function (index, slide) {
      $(slide).attr('data-slick-index', index)
    })

    // Jump back to 0
    $imagesWrapper.slick('slickGoTo', 0)
    $thumbsWrapper.slick('slickGoTo', 0)
  }

  // Change specs if needed
  const specsTab = $(`.product-details-and-specs-tab-${selectedVariant.id}`)
  $('.product-details-and-specs-tab').hide()
  if (specsTab.length) {
    specsTab.show()
  } else {
    $('.product-details-and-specs-tab-default').show()
  }

  // Description specs if needed
  const descriptionTab = $(`.product-description-tab-${selectedVariant.id}`)
  $('.product-description-tab').hide()
  if (descriptionTab.length) {
    descriptionTab.show()
  } else {
    $('.product-description-tab-default').show()
  }

  //  Note
  $('.product-main-note').hide()
  const note = $(`.product-main-note--${selectedVariant.id}`)
  if (note.length) note.show()

  // Update add to cart / preorder
  $('.product-main-preorder').hide()
  $('#product-preorder-property').attr('name', '').attr('value', '')

  if (selectedVariant.available) {
    // Is preorder?
    const preorderMessage = $(`.product-main-preorder--${selectedVariant.id}`)
    if (preorderMessage.length) {
      preorderMessage.show()

      if (selectedVariant.id == 42122490937410) {
        $('.main-product-add-to-cart').text('Add to cart')
      } else {
        $('.main-product-add-to-cart').text('Pre-order now')
      }

      $('#product-preorder-property').attr('name', 'properties[Pre-order]').attr('value', preorderMessage.text())
    } else {
      $('.main-product-add-to-cart').text('Add to Cart')
    }
    $('.main-product-add-to-cart').prop('disabled', false)
  } else {
    $('.main-product-add-to-cart').text('Out of Stock')
    $('.main-product-add-to-cart').prop('disabled', true)
    $('.product-main-preorder').hide()
  }

  try {
    // Hide embroidery for certain variants
    if (
      selectedVariant.id === tbIds.charcoal ||
      selectedVariant.id === tbIds.blueStripe ||
      selectedVariant.id === tbIds.tweed ||
      selectedVariant.id === tbIds.snowLeopard ||
      selectedVariant.id === tbIds.python
    ) {
      $('.embroidery').hide()
      $('.embroidery__checkbox').prop('checked', false).trigger('change')
    } else {
      $('.embroidery').show()
    }

    // Update embroidery background
    if (window.embroidery_details) {
      const details = window.embroidery_details[selectedVariant.id]
      if (details) {
        $('.embroidery-preview img').attr('src', details.bg)
      }
    }
  } catch (err) {
    console.log(err)
  }
}

// On variant change
$('.main-product-selector').on('change', function () {
  const root = $(this).parents('.main-product')

  // special tushbaby lite stuff
  const isTushbaby = root.find(['[name="id"][data-tushbaby]'])

  if (isTushbaby) {
    const option = $(this).parents('.main-product-option')
    const isLiteOption = option.hasClass('main-product-option--tushbaby-lite')
    const designSelect = root.find('[name="Design"]')

    if (isLiteOption) {
      designSelect.val('Tushbaby Lite')
    } else {
      designSelect.val('Tushbaby')
    }
  }

  updatePageDetails(root)
})

// Onload
$('.main-product').each(function () {
  updatePageDetails($(this))
})

// Sticky add to cart
const stickyBar = $('.main-product-sticky-bar')

if (stickyBar.length && $('.main-product-add-to-cart').length) {
  $(window).on(
    'scroll',
    throttle(function () {
      const variantUnavailable = $('.main-product-add-to-cart').prop('disabled')
      const addButtonPosition = $('.main-product-add-to-cart').offset().top
      const position = $(window).scrollTop()

      if (position > addButtonPosition && !variantUnavailable) {
        stickyBar.addClass('main-product-sticky-bar--active')
      } else {
        stickyBar.removeClass('main-product-sticky-bar--active')
      }
    }, 80)
  )
}

$('.main-product-sticky-bar-add').on('click', function () {
  $('.main-product-add-to-cart').trigger('click')
})

/*
  Complete the look
*/
$('.main-product-complete-flex-text-select').on('change', function () {
  const root = $(this).parents('.main-product-complete-flex')
  const productJsonRaw = root.attr('data-complete-product')
  const productJson = JSON.parse(productJsonRaw)
  const variantId = Number($(this).val())
  const selectedVariant = productJson.variants.find((v) => v.id === variantId)

  const price = formatMoney(selectedVariant.price).replace('.00', '')

  root.find('p').text(price)
  root.find('img').attr('src', selectedVariant.featured_image.src)
})
